import { useLocation } from "react-router-dom";
import FichaSolicitante from "../../components/funcionarios/FichaSolicitante";

function FichaLectura({ fallback }) {
  const location = useLocation();

  return (
    <FichaSolicitante
      fallback={fallback}
      stateToReturn={location.state}
    />
  );
}

export default FichaLectura;
